<script setup lang="ts">
import {
  useItineraryStore,
  usePaxStore,
  usePriceCalendarStore,
} from '@apps/main/new-desktop/core/stores';

import { useTripOverviewPageStore } from '../../stores';

import TripOverviewHeaderActionsDesktop from './TripOverviewHeaderActionsDesktop.vue';

const tripOverviewPageStore = useTripOverviewPageStore();

const paxStore = usePaxStore();
const priceCalendarStore = usePriceCalendarStore();
const itineraryStore = useItineraryStore();

interface TripOverviewNewHeaderDesktopEmits {
  (eventName: 'pax-click'): void;
  (eventName: 'edit-trip'): void;
  (eventName: 'home-airport-click'): void;
  (eventName: 'months-selector-click'): void;
}

const emit = defineEmits<TripOverviewNewHeaderDesktopEmits>();

function openPaxSelectorModal(): void {
  emit('pax-click');
}

function openEditTripModal(): void {
  emit('edit-trip');
}

function onHomeAirportClick(): void {
  emit('home-airport-click');
}

function openMonthsSelectorModal(): void {
  emit('months-selector-click');
}
</script>

<template>
  <div class="trip-overview-new-header-desktop">
    <TripOverviewHeaderActionsDesktop
      :paxes-button-text="paxStore.getPaxesButtonDetailedText"
      :home-flight-data="tripOverviewPageStore.homeFlightData"
      :trip-start-date="itineraryStore.tripStartDate"
      :number-of-destinations="tripOverviewPageStore.numberOfDestinations"
      :number-of-nights="tripOverviewPageStore.numberOfNights"
      :price-calendar-button-text="priceCalendarStore.calendarTriggerText"
      :first-destination-name="tripOverviewPageStore.getFirstDestinationName()"
      :is-user-selected-itinerary="
        itineraryStore.userSelectedItinerary !== undefined
      "
      @pax-click="openPaxSelectorModal"
      @home-airport-click="onHomeAirportClick"
      @edit-trip="openEditTripModal()"
      @months-selector-click="openMonthsSelectorModal()"
    />
  </div>
</template>

<style scoped lang="scss">
.trip-overview-new-header-desktop {
  background-color: var(--color-white);
  @include for-less-or-equal-than-1199-px {
    padding: 0 var(--spacing-24) var(--spacing-8) var(--spacing-24);
  }
  @include for-less-or-equal-than-599-px {
    padding: 0 var(--spacing-16) var(--spacing-16) var(--spacing-24);
  }
}
</style>
